import React, { useState } from "react";
import AuthContainer from "../components/AuthContainer";
import { Alert, Button, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../hooks/useAuthContext";

const Login = () => {
  const navigate = useNavigate();
  const { dispatch } = useAuthContext();

  const [error, setError] = useState();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  async function handleLogin() {
    setError("");
    setLoading(true);

    try {
      console.log(process.env.REACT_APP_BACKEND_URL);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/login`,
        data,
      );

      const { token } = response.data;

      localStorage.setItem("token", token);

      dispatch({ type: "LOGIN", payload: token });

      setSuccess(true);
      navigate("/", { replace: true });
    } catch (err) {
      setError({ message: err.response?.data?.message || "Er ging iets mis." });
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthContainer title={"Inloggen"} subTitle={`Doorgaan naar Stock Platform`}>
      <Box>
        {success && (
          <Alert sx={{ mb: 2 }} severity={"success"}>
            Je bent succesvol ingelogd
          </Alert>
        )}
        {error && (
          <Alert sx={{ mb: 2 }} severity={"error"}>
            Je e-mailadres of wachtwoord is onjuist.
          </Alert>
        )}
        <TextField
          label="Email"
          sx={{ mb: 2, width: "100%" }}
          variant="outlined"
          type="email"
          onChange={(e) =>
            setData({ ...data, username: e.target.value.trim() })
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleLogin();
            }
          }}
          disabled={loading}
        />
        <TextField
          label="Wachtwoord"
          sx={{ mb: 1, width: "100%" }}
          variant="outlined"
          type="password"
          onChange={(e) =>
            setData({ ...data, password: e.target.value.trim() })
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleLogin();
            }
          }}
          disabled={loading}
        />
      </Box>
      <Button variant={"contained"} onClick={handleLogin}>
        Login
      </Button>
    </AuthContainer>
  );
};

export default Login;
